export default __webpack_public_path__ + "404error.png";